import './ckeditor-translates'
import React from 'react'
import ReactDOM from 'react-dom'
import {startMemoryUpdateLoop} from './lazy-monitor/lazy-events'
import {LazyMonitor} from './lazy-monitor/lazy-monitor'
import {Root} from './root'

startMemoryUpdateLoop()

ReactDOM.render(
  <React.StrictMode>
    <Root />
    <LazyMonitor />
  </React.StrictMode>,
  document.getElementById('root')
)

// ReactDOM.render(<Root />, document.getElementById('root'))
